export enum InteractionType {
    EnvProd = "env_prod",
    EnvTest = "env_test",
    EnvLocal = "env_local",
    OpenOffer = "open_offer",
    OpenSponsor = "open_sponsor",
    CloseOffer = "close_offer",
    RevealOffer = "reveal_offer",
    RepeatUnlockOffer = "repeat_unlock_offer",
    FavoriteOffer = "favorite_offer",
    UnfavoriteOffer = "unfavorite_offer",
    ShareStandard = "share_standard",
    ShareApp = "share_app",
    SharePhoto = "share_photo",
    PrepareShare = "prepare_share",
    SkipVideo = "skip_video",
    TimeoutVideo = "timeout_video",
    MerchantDirections = "merchant_directions",
    SponsorDirections = "sponsor_directions",
    SeeBounceback = "see_bounceback",
    RedeemOffer = "redeem_offer",
    ThumbsUp = "thumbs_up",
    ThumbsDown = "thumbs_down",
    MerchantWebsite = "merchant_website",
    SponsorAdWebsite = "sponsor_ad_website",
    SponsorWebsite = "sponsor_website",
    MerchantReviewSite = "merchant_review_site",
    ReshowCashier = "reshow_cashier",
    SearchGPS = "search_gps",
    SearchZip = "search_zip",
    Login = "login",
    ValidateEmail = "login_email",
    VerifySignUpCode = "referrer_sign_up",
    ResetPassword = "reset_password",
    LoginEmail = "login_email",
    LoginFacebook = "login_facebook",
    LoginApple = "login_apple",
    LoginGoogle = "login_google",
    LoginSocialFail = "login_socialfail",
    LoginSocialFailApple = "login_socialfail_apple",
    LoginSocialFailGoogle = "login_socialfail_google",
    LoginSocialFailFacebook = "login_socialfail_facebook",
    LoginFail = "login_fail",
    Logout = "logout",
    ContactSponsor = "contact_sponsor",
    ContactMerchant = "contact_merchant",
    ContactSupport = "contact_support",
    InitialUseLocation = "initial_use_location",
    InitialBypassLocation = "initial_bypass_location",
    RejectLocation = "reject_location",
    AllowLocation = "allow_location",
    EnableRedeemNow = "enable_redeem_now"
}
